"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _LinkedIn = _interopRequireDefault(require("@mui/icons-material/LinkedIn"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _system = require("@mui/system");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _excluded = ["card", "popupText"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var StyledCardItem = (0, _styledComponents.default)(_Grid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  background: linear-gradient( var(--bf-lightest-teal) 0% 15%, var(--bf-core-white) 15% 90%);\n  border-width: 3px;\n  border-radius: 25px;\n  color: var(--bf-core-gray);\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: -2em;\n  padding-bottom: 1rem;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  margin-top: 100px;\n  margin-bottom: 9vw;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n  "])));
var StyledImage = _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    \n    object-position: center top;\n    max-width: 90%;\n    height: auto;\n    margin-right: 0px;\n    margin-top: -50% !important;\n    margin-top: 20px\n    margin-bottom: 30px;\n\n    "])));
var StyledPopupImage = _styledComponents.default.img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    max-width: 90%;\n    height: auto;\n    margin-right: 0px;\n"])));
var StyledEducationText = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    text-align: left;\n    margin-top: 40px;\n    margin-bottom: 10px;\n  "])));
var StyledSubheading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    teal: true,
    className: className
  }, " ", children, " ");
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 0px;\n  margin-top: 10px;\n  "])));
var StyledPopupSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h5: true,
    teal: true,
    className: className
  }, " ", children, " ");
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 0px;\n  margin-top: 15px;\n  text-align: left;\n\n  @media (min-width: ", ") {\n    margin-top: 45px;\n  }\n  "])), _bfBaseStyles.Breakpoints.m);
var StyledPopupText = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children;
  return _react.default.createElement(_Paragraph.default, {
    gray: true,
    className: className
  }, " ", children, " ");
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: left;\n  color: gray;\n  "])));
var StyledGridItem = (0, _styledComponents.default)(_Grid.default)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    justify-content: flex-end;\n    width: 32px;\n    height: 32px;\n    margin:-right: -10px !important;\n"])));
var TeamCard = function TeamCard(_ref4) {
  var card = _ref4.card,
    popupText = _ref4.popupText,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleOpen = function handleOpen() {
    setOpen(true);
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  console.log("popup og:" + popupText);
  var splitText = card.popupText.split("\n");
  var splitPopupText = {
    educationText: [],
    beforeCollegeText: [],
    endedUpDoingText: [],
    whatIDoAtBestFitText: []
  };
  var attribute = splitPopupText.educationText;
  console.log(splitText);
  for (var i = 1; i < splitText.length; i++) {
    console.log(splitText[i]);
    if (splitText[i] === "What I wanted to do before college ") {
      attribute = splitPopupText.beforeCollegeText;
      continue;
    } else if (splitText[i] === "What I ended up doing ") {
      attribute = splitPopupText.endedUpDoingText;
      continue;
    } else if (splitText[i] === "What I do at BestFit ") {
      attribute = splitPopupText.whatIDoAtBestFitText;
      continue;
    }
    console.log(JSON.stringify(attribute));
    attribute.push(splitText[i]);
  }
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledCardItem, {
    onClick: handleOpen
  }, _react.default.createElement(StyledImage, {
    src: card.memberImageUrl
  }), _react.default.createElement(_Heading.default, {
    h4: true,
    teal: true
  }, " ", card.memberName), _react.default.createElement(_Heading.default, {
    hsub: true,
    teal: true
  }, " ", card.memberPosition, " "), _react.default.createElement(_TwoColumnLayout.default, {
    variant: "SixSixRatio",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, _react.default.createElement(StyledEducationText, null, _react.default.createElement(StyledSubheading, null, " Education "), card.memberEducation.map(function (education) {
    return _react.default.createElement(_Paragraph.default, {
      gray: true
    }, " ", education, " ");
  })), _react.default.createElement(StyledGridItem, {
    item: true,
    justifyContent: "flex-end",
    alignItems: "flex-end"
  }, _react.default.createElement(_LinkedIn.default, {
    fontSize: "large",
    href: card.memberLinkedIn,
    sx: {
      mr: ["0px", "0px", "0px", "-25px"],
      mt: "10px !important",
      ml: "10px !important"
    }
  })))), _react.default.createElement(_Modal.default, {
    open: open,
    onClose: handleClose,
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'transparent'
    }
  }, _react.default.createElement(_system.Box, {
    sx: {
      background: 'linear-gradient( var(--bf-lightest-teal) 0% 10%, var(--bf-core-white) 10% 90%)',
      border: 'transparent',
      borderWidth: "3px",
      borderRadius: "25px",
      textAlign: "center",
      width: '70%',
      pb: '20px',
      pt: '1rem'
    }
  }, _react.default.createElement(_Close.default, {
    onClick: handleClose,
    justifyContent: "right",
    sx: {
      color: "var(--bf-core-white)",
      display: "flex",
      pt: "-25px !important",
      ml: "10px"
    }
  }, " "), _react.default.createElement(_TwoColumnLayout.default, {
    variant: "SixSixRatio",
    justifyContent: "space-around"
  }, _react.default.createElement(_Grid.default, {
    item: true,
    justifyContent: "center",
    xs: 10,
    sm: 8,
    md: 4,
    lg: 4,
    xl: 4
  }, _react.default.createElement(StyledPopupImage, {
    src: card.memberImageUrl,
    sx: {
      mb: "25px"
    }
  }), _react.default.createElement(_Heading.default, {
    h4: true,
    teal: true,
    sx: {
      mb: "25px"
    }
  }, " ", card.memberName), _react.default.createElement(_Heading.default, {
    hsub: true,
    teal: true
  }, " ", card.memberPosition, " ")), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 4.5,
    lg: 6,
    xl: 6
  }, _react.default.createElement(StyledPopupSubheading, null, " Education "), splitPopupText.educationText.map(function (text) {
    return _react.default.createElement(StyledPopupText, {
      gray: true
    }, " ", text, " ");
  }), _react.default.createElement(StyledPopupSubheading, null, " What I wanted to do before college "), splitPopupText.beforeCollegeText.map(function (text) {
    return _react.default.createElement(StyledPopupText, {
      gray: true
    }, " ", text, " ");
  }), _react.default.createElement(StyledPopupSubheading, null, " What I ended up doing "), splitPopupText.endedUpDoingText.map(function (text) {
    return _react.default.createElement(StyledPopupText, {
      gray: true
    }, " ", text, " ");
  }), _react.default.createElement(StyledPopupSubheading, null, " What I do at BestFit "), splitPopupText.whatIDoAtBestFitText.map(function (text) {
    return _react.default.createElement(StyledPopupText, {
      gray: true
    }, " ", text, " ");
  }))))));
};
var _default = TeamCard;
exports.default = _default;